import React, { useState, useEffect } from 'react';
import './App.css';
import useLocalStorage from 'use-local-storage';
// import Loader from './components/preloader/Loader';
import SiteData from './components/SiteData';


function App() {
  const [isLoading, setIsLoading] = useState(true)
    

    useEffect(() => {
        setTimeout(() => {

            setIsLoading(false);
        },1000);        
    },[])

     // DAYNIGHT THEME SESSION
     const [theme, setTheme] = useLocalStorage('theme' ? 'dark': 'light')

     const themeSwitch = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
         setTheme(newTheme)
     }
    

  return (
    <>
      {
        isLoading ? <div class="load" data-theme={theme}><hr/><hr/><hr/><hr/></div>
    :
      <SiteData />
      }    
    </>
  );
}

export default App;
